import { Trans } from '@lingui/react'

// @ts-ignore
const PrescriptionIssuedTo = ({ prescriptionIssuedTo }) =>
  prescriptionIssuedTo && (
    <div className="u-margin-x-small--top">
      <span className="u-font-weight--bold">
        <Trans
          id="general.label.issuedTo"
          values={{
            issuedTo: (
              <span className="u-font-weight--normal u-display--inline-block u-display--block@small-tiny">
                {prescriptionIssuedTo}
              </span>
            ),
          }}
        />
      </span>
    </div>
  )

export default PrescriptionIssuedTo
